import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange, 
        selectedCardsGroupsChange, 
        setCycleData } from '../../../actions/index'

import Icon from '@mdi/react';
import { mdiGoogleCirclesCommunities } from '@mdi/js';

import { _ } from '../../../functions/translator'
import { handlePosition, 
        handleVisibility } from '../../../functions/popUpMenu/visibiltyFunctions';

class AsignCycleButton extends React.Component{
          
    componentDidMount() {
        setTimeout(() => {
            this.button.classList.add(`button-transition-${this.props.index}`)
            handleVisibility(this.button, !this.props.popUpMenu.close)
            handlePosition(this.button, this.props.position, !this.props.popUpMenu.close)
        }, 1);
    }

    handleClick = () => {
        this.props.popUpMenuChange({
            show: false,
            close: false,
            opacity: this.props.popUpMenu.opacity ? 0 : 1,
            cyclesButton: false
        })
        this.props.selectedCardsGroupsChange([])
        const allCardsGroupIds = [];
        for (const cardsGroupId of this.props.mergeableCardsGroups.cardsGroupIds) {
            allCardsGroupIds.push(cardsGroupId);
        }
        for (const cardsGroupId of this.props.separableCardsGroups) {
            if (!allCardsGroupIds.includes(cardsGroupId)) {
                allCardsGroupIds.push(cardsGroupId);
            }
        }
        this.props.setCycleData({ 
            show: true, 
            cardsGroupIds: allCardsGroupIds,
        })
    }

    render(){   
        if (this.button) {
            let isHide = !this.props.popUpMenu.close || this.props.popUpMenu.closeList || !this.props.popUpMenu.cyclesButton
            handleVisibility(this.button, isHide)
            handlePosition(this.button, this.props.position, !this.props.popUpMenu.close)
        }
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiGoogleCirclesCommunities } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Generar Ciclo') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        projectData : state.projectData,
        selectedCardsGroups : state.selectedCardsGroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        setCycleData : setCycleData
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AsignCycleButton)